import "./categoryFilter.scss";
import { router } from "@inertiajs/react";
import { buildLocalePath } from "@frontend/js/utils/locale";

export default function CategoryFilter({
    filters = [],
    selectedFilterId = null,
    allLabel = "All",
    pageSlug,
    locale = null,
}) {
    const handleFilterClick = (filter) => {
        const category = filter.id === null ? null : filter.id;

        router.get(
            buildLocalePath(locale, pageSlug),
            { category, page: 1 },
            { preserveScroll: true },
        );
    };

    return (
        <div className="category-filter">
            <button
                type="button"
                className={[
                    "category-filter__button",
                    selectedFilterId === null
                        ? "category-filter__button--active"
                        : "",
                ]
                    .filter(Boolean)
                    .join(" ")}
                onClick={() => handleFilterClick({ id: null })}
            >
                {allLabel}
            </button>
            {filters?.map((filter) => (
                <button
                    key={filter.id}
                    type="button"
                    className={[
                        "category-filter__button",
                        selectedFilterId === filter.id
                            ? "category-filter__button--active"
                            : "",
                    ]
                        .filter(Boolean)
                        .join(" ")}
                    onClick={() =>
                        handleFilterClick({ id: filter.id, value: filter.slug })
                    }
                >
                    {filter.title?.[locale] || filter.title}
                </button>
            ))}
        </div>
    );
}
